import { gql } from "@apollo/client";

export const CREATE_PAYMENT_FOR_DEPOSIT = gql`
  mutation createPaymentForDeposit(
    $payment: CreateDepositPaymentInput!
    $convergePOSTransaction: Boolean
  ) {
    createPaymentForDeposit(
      payment: $payment
      convergePOSTransaction: $convergePOSTransaction
    ) {
      success
      message
      payment {
        id
        stripeCheckoutSessionId
        convergePaymentSessionUrl
        convergePaymentLinkId
        convergeUSSessionToken
        booking {
          id
        }
      }
    }
  }
`;
